import * as React from "react";
import "./ExceedMaxPriceBalanceModalView.scss";
import { DataGrid } from 'devextreme-react';
import { Column } from 'devextreme-react/data-grid';
import { MoneyMask } from 'src/util/Masks/MoneyMask';
import { Collapse } from 'antd';
import { IExceedMaxPriceBalanceTransaction } from "src/services/interfaces/IExceedMaxPriceBalanceTransaction";
import { BalanceTransactionStatusEnum, BalanceTypeLabel } from "src/services/Enum/BalanceTransactionStatusEnum";
import { formatCurrency } from "src/util/Masks/formatCurrency";
import { IExceedMaxPriceBalance } from "src/services/interfaces/IExceedMaxPriceBalance";

interface IExceedMaxPriceBalanceModalProps {
  balance: IExceedMaxPriceBalance;
}

export const ExceedMaxPriceBalanceModalView: React.FC<IExceedMaxPriceBalanceModalProps> = ({ balance }) => {
  const { Panel } = Collapse;

  return (
    <>
      <div className="analysis-modal wrap">
        <div className="span-wrap card success">
          <span className="label">Disponível</span>
          {balance && <span className="value">{formatCurrency(balance?.available)}</span>}
        </div>
        <div className="span-wrap card default">
          <span className="label">Provisionado</span>
          {balance && <span className="value">{formatCurrency(balance?.provisioned)}</span>}
        </div>
        <div className="span-wrap card warning">
          <span className="label">Utilizado</span>
          {balance && <span className="value">{formatCurrency(balance?.debited)}</span>}
        </div>
      </div>
      {balance &&
        <Collapse defaultActiveKey={['1', '2']} style={{ marginBottom: "20px" }}>
          <Panel header="Saldo em aberto" key="1">
            <DataGrid
              className="max-price-transactions-grid"
              dataSource={balance.transactions.filter(t => [BalanceTransactionStatusEnum.PROVISIONED, BalanceTransactionStatusEnum.PRE_AVAILABLE].includes(t.status))}
              rowAlternationEnabled
              showBorders
              columnAutoWidth
            >
              <Column
                caption="Saldo provisionado"
                alignment="center"
              >
                <Column
                  format="dd/MM/yyyy"
                  caption="Data da movimentação"
                  alignment="center"
                  dataType="date"
                  dataField="transactionDate"
                />
                <Column
                  caption="Valor"
                  alignment="center"
                  dataType="number"
                  dataField="amount"
                  cellRender={(params: { data: IExceedMaxPriceBalanceTransaction }) => {
                    return <p className="grid-value default">{`${MoneyMask(params.data.amount)}`} </p>
                  }}
                />
                <Column
                  caption="Trade"
                  alignment="center"
                  dataType="number"
                  dataField="tradeId"
                />
                <Column
                  caption="Movimentação"
                  alignment="center"
                  dataType="string"
                  dataField="from"
                  cellRender={(params: { data: IExceedMaxPriceBalanceTransaction }) => {
                    return <>
                      {`${BalanceTypeLabel.get(params.data.status)}`}
                    </>
                  }

                  }
                />
              </Column>

            </DataGrid>
          </Panel>
          <Panel header="Saldo Histórico" key="2">
            <DataGrid
              className="max-price-transactions-grid"
              dataSource={balance.transactions.filter(t => [BalanceTransactionStatusEnum.AVAILABLE, BalanceTransactionStatusEnum.DEBITED].includes(t.status))}
              rowAlternationEnabled
              showBorders
              columnAutoWidth
            >
              <Column
                caption="Histórico"
                alignment="center"
              >
                <Column
                  format="dd/MM/yyyy"
                  caption="Data da movimentação"
                  alignment="center"
                  dataType="date"
                  dataField="transactionDate"
                />
                <Column
                  caption="Valor"
                  alignment="center"
                  dataType="string"
                  dataField="amount"
                  cellRender={(params: { data: IExceedMaxPriceBalanceTransaction }) => {
                    if (params.data.status === BalanceTransactionStatusEnum.AVAILABLE) {
                      return <p className="grid-value success">{`+ ${MoneyMask(params.data.amount)}`} </p>
                    } else {
                      return <p className="grid-value warning">{`${MoneyMask(params.data.amount)}`} </p>
                    }
                  }}
                />

                <Column
                  caption="Trade"
                  alignment="center"
                  dataType="number"
                  dataField="tradeId"
                />
                <Column
                  caption="Movimentação"
                  alignment="center"
                  dataType="string"
                  dataField="from"
                  cellRender={(params: { data: IExceedMaxPriceBalanceTransaction }) => {
                    return <>
                      {`${BalanceTypeLabel.get(params.data.status)}`}
                    </>
                  }}
                />
              </Column>
            </DataGrid>
          </Panel>
        </Collapse>
      }
    </>
  );
}



// WEBPACK FOOTER //
// ./src/components/common/CommissionView/ExceedMaxPriceBalance/ExceedMaxPriceBalanceModalView.tsx